import * as React from 'react'
import { useEffect } from 'react'

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import SortOrder from '~/client/src/shared/enums/SortOrder'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import AttachmentsSortingOptionsStore from './AttachmentsSortingOptions.store'

import './AttachmentsSortingOptions.scss'

// localization: no display text to translate

interface IProps {
  store: AttachmentsSortingOptionsStore
  forceClose: boolean
}
const ICON_SIZE = 12

const AttachmentsSortingOptions: React.FC<IProps> = observer(
  ({ store, forceClose }) => {
    useEffect(() => {
      store.initializeFromStore()
    }, [store])

    useEffect(() => {
      if (forceClose) {
        store.hideSortingOptions()
      }
    }, [forceClose, store])

    const renderToggleButton = (): JSX.Element => {
      const sortByText = Localization.translator.sortBy

      return (
        <div
          className="w-max-content sorting-toggle-button cursor-pointer row x-center y-center no-flex no-flex-children pointer"
          onClick={store.toggleSortingOptions}
        >
          <span className="mr4 text large">{store.sortByIcon}</span>
          <span className="mr4 text large">{sortByText}:</span>
          <span className="sorting-current-option mr4 text large">
            {store.sortByCaption}
          </span>
          {store.isShown ? (
            <ChevronUpIcon size={ICON_SIZE} />
          ) : (
            <ChevronDownIcon size={ICON_SIZE} />
          )}
        </div>
      )
    }

    const renderDropdown = (): JSX.Element => {
      return (
        <div className="sorting-options-dropdown">
          <div className="sorting-options-list">
            {store.sortingOptions.map(option => (
              <div
                key={option.id}
                className={classList({
                  'sorting-option-item pointer': true,
                  selected: store.selectedSortingOptionId === option.id,
                })}
                onClick={() => store.selectSortingOption(option.id)}
              >
                <span>{option.caption}</span>
                {store.selectedSortingOptionId === option.id && (
                  <span className="sort-order-indicator ml4">
                    {store.selectedSortOrder === SortOrder.ASC ? '↑' : '↓'}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )
    }

    return (
      <div className="sorting-options-container">
        {renderToggleButton()}
        {store.isShown && renderDropdown()}
      </div>
    )
  },
)

export default AttachmentsSortingOptions
